'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024$0024anon$0024155 from "./presto.types$-Two-Factor-Auth-Payload$$anon$155.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024$0024anon$0024157 from "./presto.types$-Two-Factor-Auth-Payload$$anon$157.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024$0024anon$0024159 from "./presto.types$-Two-Factor-Auth-Payload$$anon$159.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthPayload$() {
  this.ccp = null;
  this.ccq = false;
}
export { $c_Lpresto_types$TwoFactorAuthPayload$ as $c_Lpresto_types$TwoFactorAuthPayload$ };
$p = $c_Lpresto_types$TwoFactorAuthPayload$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthPayload$;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthPayload$() {
}
export { $h_Lpresto_types$TwoFactorAuthPayload$ as $h_Lpresto_types$TwoFactorAuthPayload$ };
$h_Lpresto_types$TwoFactorAuthPayload$.prototype = $p;
$p.zf = (function() {
  if ((!this.ccq)) {
    this.ccp = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$35(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((c) => {
      var this$2 = c.z0("type");
      var x384 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa.F(this$2);
      if ((x384 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Right)) {
        var x390 = x384.bU;
        if ((x390 === "TwoFactorAuthEmailPayload")) {
          $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$();
          return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024$0024anon$0024155.$c_Lpresto_types$TwoFactorAuthPayload$$anon$155(), c);
        }
        if ((x390 === "TwoFactorAuthSeedPayload")) {
          $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$();
          return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024$0024anon$0024157.$c_Lpresto_types$TwoFactorAuthPayload$$anon$157(), c);
        }
        if ((x390 === "TwoFactorAuthErrorPayload")) {
          $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$();
          return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024$0024anon$0024159.$c_Lpresto_types$TwoFactorAuthPayload$$anon$159(), c);
        }
      }
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Left($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_DecodingFailure$().nr("Unknown type", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction0(((c$2) => (() => c$2.eM()))(c))));
    }))));
    this.ccq = true;
  }
  return this.ccp;
});
var $d_Lpresto_types$TwoFactorAuthPayload$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthPayload$, "presto.types$TwoFactorAuthPayload$", ({
  a2l: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_types$TwoFactorAuthPayload$ as $d_Lpresto_types$TwoFactorAuthPayload$ };
var $n_Lpresto_types$TwoFactorAuthPayload$;
function $m_Lpresto_types$TwoFactorAuthPayload$() {
  if ((!$n_Lpresto_types$TwoFactorAuthPayload$)) {
    $n_Lpresto_types$TwoFactorAuthPayload$ = new $c_Lpresto_types$TwoFactorAuthPayload$();
  }
  return $n_Lpresto_types$TwoFactorAuthPayload$;
}
export { $m_Lpresto_types$TwoFactorAuthPayload$ as $m_Lpresto_types$TwoFactorAuthPayload$ };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Payload$.js.map
